import type { FaireProductEntity } from "../../entity_types/product";

export const p_hhck9gk33d: FaireProductEntity = {
  token: "p_hhck9gk33d",
  type: "product",
  name: "925 Sterling Silver Sparkling Moissanite Stacking Ring",
  brandToken: "b_9a7m2r54fa",
  brandName: "Gioiellin - S925 Silver Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/1f87ae36ded4480357e1d8f006ab33fa9e9d3fa354be5fa05bdf199f61cfab02.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5bf3dcd92cf56380e437207973568e75cbcb9732867e5d99777b3ef4d17a4d7f.jpeg",
    "https://cdn.faire.com/fastly/74c9d2ada3fbb1c5f80e9ba3263a791ee366614c8957d9625b3eacd1e853c04c.jpeg",
    "https://cdn.faire.com/fastly/d1630331042c5527b83f6a087adb262c31a1e614fa1534321804c5c18f844419.jpeg",
    "https://cdn.faire.com/fastly/5fa62bd32ee8a11fc4866a7034d02819baa48050bab033c03be84e33177b6ba2.jpeg",
  ],
  priceDollars: 59.58,
  description:
    "'-ID: GIO-WES-MORI2508\n-Material: S925 Sterling Silver\n-Electroplating Process: Electrophoretic Paint\n-Color: Silvery(Sterling Silver with Platinum Plating)\n-Main Stone(s): Moissanite(Synthetic), 6.5mm(1ct)\n-Stone(s) Color: D\n-Stone(s) Clarlty: VVS1\n-Stone(s) Cut: 3EX\n-Side Stone(s): Synthetic Cubic Zirconia\n-Size: 6,7,8 (Standard US Size)\n-Thick: 11mm\n-Weight(s):3.62g\nShine with elegance in this moissanite engagement ring made of genuine 925 sterling silver. The brilliant round-cut moissanite sparkles like a real diamond, offering an affordable and ethical alternative. Its cushion halo design with side stones adds timeless charm and extra sparkle. Hypoallergenic and nickel-free, it's safe for daily wear. A perfect gift for engagements, proposals, Wedding, anniversaries, or romantic moments. Comes in a luxury gift box to impress the one you love.",
  tags: [],
  msrpDollars: 119.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:58.714Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
